module.exports = __webpack_public_path__ + "media/video3-es.985f775c.mp4";